import styled from '@emotion/styled';

import { mq } from '@hrworks/design-system/utilities';

const Notifications = styled.div(({ theme }) => ({
  filter: theme.eclipseTier2Color.elevation.shadow.level1.dropShadow,
  position: 'fixed',
  zIndex: theme.marko.variables.zIndex.notifications,
  right: 6,
  left: 6,
  gap: 6,
  bottom: 30,
  display: 'flex',
  flexDirection: 'column',

  [mq['>=sm']]: {
    right: 30,
    left: 'unset',
    width: 400,
  },
}));

export const S = {
  Notifications,
};
